import { APIConfig, PageAPIResp } from '../models/api-config.model';

/**
 * Function to set the initial state of "allAPIsResp" object.
 * @param allAPIsResp - Object where UI state is handled.
 * @param key - Key of the data in "allAPIsResp" object.
 */
function initAPIsRespObj(allAPIsResp: PageAPIResp, key: string) {
  if (!allAPIsResp[key]) {
    allAPIsResp[key] = <any>{};
  }
  allAPIsResp[key].isLoading = true;
  allAPIsResp[key].data = null;
}

/**
 * Function that iterates the array of API configs & marks "isLoading" and "data" of the config.
 * @param apiConfig - Array of API configs from APIConfigService.
 * @param allAPIsResp - Object where UI state is handled.
 * @param cb - [Optional] Callback to call when 'getDataObs$' resolves.
 */
export function iterateAPIConfig(
  apiConfig: APIConfig[],
  allAPIsResp: PageAPIResp,
  cb?: () => void
) {
  apiConfig.forEach((config) => {
    initAPIsRespObj(allAPIsResp, config.key);
    config.getDataObs$.subscribe((data) => {
      allAPIsResp[config.key].isLoading = false;
      allAPIsResp[config.key].data = data;
      cb && cb();
    });
  });
}
